const {
  getCandInfo,
  postCandInfo,
  postCandEdu,
  putCandEdu,
  postCandExp,
  putCandExp,
  putCandSkills,
  postCandSkills,
  postCandInterSkills,
  postCandDomain,
  putCandDomain,
  putProjectEdit,
  postProjectsInfo,
  putCandAchieve,
  putCandAward,
  putCandEvent,
  postCandAchieve,
  postCandAward,
  postCandEvent,
  addPortfolio,
  deleteCandEdu,
  deleteCandExp,
  deleteCandProject,
  deleteCandDomain,
  deleteCandskills,
  deleteCandAchieve,
  deleteCandEvent,
  deleteCandAward,
  deleteCandPortfolio,
  putCandPortfolio,
  postCandAchieveFileUpload,
  getUserCredits,
  createOrder,
  goToPayment,
  checkCustomerExists,
  createCustomer,
  getLocation,
  addUserCredits,
  getCandidatePrimaryProfile,
} = require("@/utils/apiFunctions");
const { Capacitor } = require("@capacitor/core");
const { Geolocation } = require("@capacitor/geolocation");
const { goToBoard } = require("./helpers.js");
const getCandidateDetail = async (context, id = null) => {
  try {
    const response = await getCandInfo(id);
    if (response.status === 200) {
      return response.data.data;
    } else if (response.status == 404) {
      const res2 = await getCandidatePrimaryProfile()
      return res2.data.data;
    }
  } catch (error) {
    console.log(error);
  }
};

const addBasicDetail = async (context) => {
  context.$v.$touch();
  context.dobDirty = true;
  if (!context.$v.$invalid && !context.dobCheck) {
    try {
      context.loading = true;
      let data = {};
      for (let key of context.keys) {
        data[key] = context[key];
      }
      data.email = context.email;
      const response = await postCandInfo(data);
      if (response.status === 200) {
        context.loading = false;
        context.$nextTick(() => {
          context.successModal(
            "Successfully added",
            "Demographics has been added"
          );
        });
        if (context.$route.name === "BasicDetail") {
          goToBoard(context);
        } else {
          context.loading = false;
          context.$emit("update-data", "showBasicModal");
        }
      }
    } catch (error) {
      context.loading = false;
      console.log(error);
    }
  }
};

const addBasicDetailNew = async (context) => {
  // context.$v.$touch();
  let demographicsValid = true;
  for (let key in context.demographicsDetails) {
    if (context.$v[key]?.$invalid) {
      demographicsValid = false;
      break;
    }
  }
  context.dobDirty = true;

  if (context.willingToRelocateTo.length < 1) {
    context.iswillingToRelocateToError = false;
  }
  if (
    demographicsValid &&
    !context.dobCheck &&
    // !context.salaryCheck &&
    !context.nationalityError &&
    !context.iswillingToRelocateToError &&
    !context.isLanguagesInvalid &&
    !context.isError
  ) {
    try {
      context.loading = true;
      let data = {};
      for (let key of context.keys) {
        data[key] = context[key];
      }
      data.email = context.email;
      data.id = context.getcandidateInfo._id;
      const response = await postCandInfo(data);
      if (response.status === 200) {
        context.loading = false;
        if (context.buttonText == "Update") {
          context.$emit("update-data", "showBasicModalFullNew");
          context.$nextTick(() => {
            context.successModal(
              "Successfully updated",
              "Demographics have been updated"
            );
          });
        } else {
          context.$emit("update-data", "showBasicModalFullNew");
          context.$nextTick(() => {
            context.successModal(
              "Successfully Saved",
              "Demographics have been saved"
            );
          });
        }
      }
    } catch (error) {
      context.loading = false;
      console.log(error);
    }
  } else {
    context.$v.$touch();
  }
};

const addEducation = async (payload, context, keepOpen) => {
  try {
    const response = await postCandEdu(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;
      if (context.$route.name === "Education") {
        goToBoard(context);
      } else {
        context.loading = false;
        context.education = {
          institute: null,
          location: null,
          qualification: null,
          fieldOfStudy: null,
          courseDuration: null,
          gradePercentage: null,
          yearOfJoining: null,
          yearOfPassout: null,
          currentEducation: false,
        };
        context.yearOfJoining = null;
        context.monthOfJoining = null;
        context.yearOfPassout = null;
        context.monthOfPassout = null;
        context.displayMonthPlaceholder = "";
        context.displayYearPlaceholder = "";
        context.displayPassOutMonthPlaceholder = "";
        context.displayPassOutYearPlaceholder = "";
        context.isUpdateClicked = false;
        context.$v.education.$reset();
        context.$emit("update-data", {
          modal: "showEducationModal",
          keepOpen,
        });
        context.$nextTick(() => {
          context.successModal(
            "Successfully added",
            "Education has been added"
          );
        });
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editEducation = async (payload, context) => {
  try {
    const response = await putCandEdu(payload);
    if (response.status === 200) {
      context.loading = false;
      if (context.$route.name === "Education") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showEducationModal");
        context.$nextTick(() => {
          context.successModal(
            "Successfully updated",
            "Education have been updated"
          );
        });
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateEducation = (context, keepOpen) => {
  context.$v.education.$touch();
  context.isUpdateClicked = true;
  if (
    !context.disableDegree &&
    (context.education.degree == "" || context.education.degree == null)
  ) {
    context.errorDegree = true;
  } else {
    context.errorDegree = false;
  }
  if (
    !context.qualificationError &&
    !context.errorDegree &&
    !context.$v.education.$invalid &&
    (context.education.currentEducation || context.isPassOutDateFilled) &&
    context.isJoiningDateFilled
    // && !context.wrongEduYear
  ) {
    context.loading = true;
    if (keepOpen) context.saveAndNewClicked = true;

    let payload = {
      email: context.email,
      id: context.getcandidateInfo._id,
    };
    let payload2 = {
      email: context.email,
      parser: true,
      id: context.getcandidateInfo._id,
    };
    if (context.modalType === "add" || context.modalType === "addParser") {
      payload.educationalInfo = [context.education];
      addEducation(payload, context, keepOpen);
    } else if (context.modalType === "edit") {
      payload.educationalInfo = { ...context.education };
      editEducation(payload, context);
    } else {
      payload2.educationalInfo = { ...context.education };
      editEducation(payload2, context);
    }
  }
};

const addExperience = async (payload, context, keepOpen) => {
  try {
    const response = await postCandExp(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;

      context.experience = {
        companyName: null,
        location: null,
        designation: null,
        jobType: null,
        startDate: null,
        endDate: null,
        currentExperience: false,
        highlight: [""],
      };
      context.$v.experience.$reset();
      context.$emit("update-data", {
        modal: "showExperienceModal",
        keepOpen,
      });
      context.$nextTick(() => {
        context.successModal("Successfully added", "Experience has been added");
        context.isexepHihlightReq = false;
      });
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editExperience = async (payload, context) => {
  try {
    const response = await putCandExp(payload);
    if (response.status === 200) {
      context.loading = false;

      context.$emit("update-data", "showExperienceModal");
      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Experience have been updated"
        );
      });
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateExperience = (context, keepOpen) => {
  let myRespContext = JSON.parse(JSON.stringify(context.experience));
  context.$v.experience.$touch();
  if (
    !context.$v.experience.$invalid &&
    !context.isexepHihlightReq &&
    !context.invalidEndDate
  ) {
    context.loading = true;
    if (keepOpen) context.saveAndNewClicked = true;
    let payload = {
      email: context.email,
      id: context.getcandidateInfo._id,
    };
    if (context.experience.highlight.includes("")) {
      let tempArray = Array.from(context.experience.highlight);
      let emptyIndex = tempArray.indexOf("");
      while (emptyIndex !== -1) {
        tempArray.splice(emptyIndex, 1);
        emptyIndex = tempArray.indexOf("");
      }
      myRespContext.highlight = Array.from(tempArray);
    }

    if (context.modalType === "add" || context.modalType === "addParser") {
      payload.experience = [myRespContext];
      addExperience(payload, context, keepOpen);
    } else {
      payload.experience = { ...myRespContext };
      editExperience(payload, context);
    }
    context.$v.experience.$reset();
    context.isexepHihlightReq = false;
  }
};

const addSkill = async (context, payload, payload2) => {
  try {
    const response = await postCandSkills(payload);
    if (response.status === 200) {
      context.loading = false;
      await addInterSkill(context, payload2);
      if (context.modalType == "add") {
        context.$nextTick(() => {
          context.successModal("Successfully added", "Skill has been added");
        });
      } else if (context.delCheck && context.delCheck == true) {
        context.$nextTick(() => {
          context.successModal(
            "Successfully deleted",
            "Skill have been deleted"
          );
        });
      } else {
        context.$nextTick(() => {
          context.successModal(
            "Successfully updated",
            "Skill have been updated"
          );
        });
      }
      // context.$emit("update-data", "showSkillsModalNew");
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};
const addInterSkill = async (context, payload) => {
  try {
    const response = await postCandInterSkills(payload);
    if (response.status === 200) {
      context.loading = false;
      if (context.$route.name === "Skills") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showSkillsModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editSkill = async (context, payload) => {
  try {
    const response = await putCandSkills(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal("Successfully updated", "Skill have been updated");
      });
      if (context.$route.name === "Skills") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showSkillsModal");
      }
    } else {
      context.loading = false;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateSkill = async (context) => {
  if (context.addedSkillButton) {
    context.$v.skill.$touch();
    return !context.$v.skill.$invalid;
  } else if (context.addedSkillButton2) {
    context.$v.interpersonalSkill.$touch();
    return !context.$v.interpersonalSkill.$invalid;
  } else {
    context.loading = true;
    let payload = {
      email: context.email,
      id: context.getcandidateInfo._id,
      parser: context.parserSkill,
    };
    let payload2 = {
      email: context.email,
      id: context.getcandidateInfo._id,
      parser: context.parserSkill,
    };
    payload.skills = [...context.skillAdded, ...context.skillAddedParser];
    payload2.interpersonalSkills = [
      ...context.InterskillAdded,
      ...context.interpersonalSkillAddedParser,
    ];

    addSkill(context, payload, payload2);
  }
};

const addDomain = async (context, payload) => {
  try {
    const response = await postCandDomain(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal("Successfully added", "Domain has been added");
      });
      if (context.$route.name === "Domain") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showDomainModal");
      }
    } else {
      context.loading = false;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editDomain = async (context, payload) => {
  try {
    const response = await putCandDomain(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Domain have been updated"
        );
      });
      if (context.$route.name === "Domain") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showDomainModal");
      }
    } else {
      context.loading = false;
      context.$nextTick(() => {
        context.errorModal("Error", "Something went wrong");
      });
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateDomain = (context) => {
  context.$v.domain.$touch();
  if (!context.$v.domain.$invalid) {
    context.loading = true;
    let payload = {
      email: context.email,
    };
    if (context.modalType === "add") {
      payload.domain = [context.domain];
      addDomain(context, payload);
    } else {
      payload.domain = { ...context.domain };
      editDomain(context, payload);
    }
  }
};

const addAchieve = async (context, payload, keepOpen) => {
  try {
    const response = await postCandAchieve(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully added",
          "Achievement has been added"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.achievement = {
          achieveType: null,
          title: null,
          issuingOrganization: "",
          uploadFile: null,
          description: null,
          issueDate: null,
          expirationDate: null,
          isExpire: false,
          usedSkills: [],
          link: null,
          certificateID: null,
        };
        context.closeModal();
        context.$v.achievement.$reset();
        context.$emit("update-data", {
          modal: "showAchieveModalNew",
          keepOpen,
        });
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};
const addAward = async (context, payload, keepOpen) => {
  try {
    const response = await postCandAward(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully added",
          "Achievement has been added"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.achievement = {
          achieveType: null,
          title: null,
          issuingOrganization: "",
          uploadFile: null,
          description: null,
          issueDate: null,
          expirationDate: null,
          isExpire: false,
          usedSkills: [],
          link: null,
          certificateID: null,
        };
        context.closeModal();
        context.$v.achievement.$reset();
        context.$emit("update-data", {
          modal: "showAchieveModalNew",
          keepOpen,
        });
      }
    } else {
      context.loading = false;
      // context.$nextTick(() => {
      //   context.errorModal("Error", "Something went wrong");
      // });
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const addEvent = async (context, payload, keepOpen) => {
  try {
    const response = await postCandEvent(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully added",
          "Achievement has been added"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.achievement = {
          achieveType: null,
          title: null,
          issuingOrganization: "",
          uploadFile: null,
          description: null,
          issueDate: null,
          expirationDate: null,
          isExpire: false,
          usedSkills: [],
          link: null,
          certificateID: null,
        };
        context.$v.achievement.$reset();
        context.$emit("update-data", {
          modal: "showAchieveModalNew",
          keepOpen,
        });
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editAchieve = async (context, payload) => {
  try {
    const response = await putCandAchieve(payload);
    if (response.status === 200) {
      context.loading = false;

      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Achievement have been updated"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showAchieveModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};
const editAward = async (context, payload) => {
  try {
    const response = await putCandAward(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Achievement have been updated"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showAchieveModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editEvent = async (context, payload) => {
  try {
    const response = await putCandEvent(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Achievement have been updated"
        );
      });
      if (context.$route.name === "Achievement") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showAchieveModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateAchieve = async (context, keepOpen) => {
  if (
    context.fileUploaded &&
    context.achievement.achieveType != "event" &&
    context.uploadFrom != null
  ) {
    const readers = new FileReader();
    readers.readAsDataURL(context.file);
    try {
      let form = new FormData();
      form.append("email", context.email);
      form.append("file", context.file);
      if (context.achievement.achieveType == "certificate") {
        form.append("bucketKey", "certifications");
      } else {
        form.append("bucketKey", "awards");
      }
      form.append("id", context.getcandidateInfo._id);
      const response = await postCandAchieveFileUpload(form);
      if (response.status == 200) {
        context.achievement.uploadFile = response.data.data.key;
        // return context.achievement.uploadFile;
      }
    } catch (error) {
      console.log(error);
    }
  }
  if (context.achievement.achieveType == "certificate") {
    context.$v.achievement.$touch();
    if (!context.$v.achievement.$invalid && !context.invalidEndDate) {
      context.loading = true;
      if (keepOpen) context.saveAndNewClicked = true;

      let payload = {
        email: context.email,
        id: context.getcandidateInfo._id,
      };
      if (context.modalType === "add" || context.modalType === "addParser") {
        payload.achievement = [context.achievement];
        addAchieve(context, payload, keepOpen);
      } else {
        payload.achievement = { ...context.achievement };
        editAchieve(context, payload);
      }
    } else {
      context.saveClicked = false;
    }
  }
  //Only if achieveType is "award" type
  if (context.achievement.achieveType == "award" && !context.invalidEndDate) {
    context.$v.achievement.$touch();
    if (!context.$v.achievement.$invalid) {
      context.loading = true;
      if (keepOpen) context.saveAndNewClicked = true;

      let payload = {
        email: context.email,
        id: context.getcandidateInfo._id,
      };
      if (context.modalType === "add" || context.modalType === "addParser") {
        payload.awards = [context.achievement];
        addAward(context, payload, keepOpen);
      } else {
        payload.awards = { ...context.achievement };
        editAward(context, payload);
      }
    } else {
      context.saveClicked = false;
    }
  }
  //Only if achieveType is "event" type
  if (context.achievement.achieveType == "event" && !context.invalidEndDate) {
    console.log("In eventtt", context.achievement, context.modalType);
    context.$v.achievement.achieveType.$touch();
    context.$v.achievement.title.$touch();
    context.$v.achievement.issueDate.$touch();
    context.$v.achievement.issuingOrganization.$touch();
    if (
      !context.$v.achievement.achieveType.$invalid &&
      !context.$v.achievement.title.$invalid &&
      !context.$v.achievement.issueDate.$invalid &&
      !context.$v.achievement.issuingOrganization.$invalid
    ) {
      context.loading = true;
      if (keepOpen) context.saveAndNewClicked = true;

      let payload = {
        email: context.email,
        id: context.getcandidateInfo._id,
      };
      if (context.modalType === "add") {
        const {
          achieveType,
          description,
          issueDate,
          title,
          issuingOrganization,
        } = context.achievement;
        payload.events = [
          { achieveType, description, issueDate, title, issuingOrganization },
        ];
        addEvent(context, payload, keepOpen);
      } else if (context.modalType === "addParser") {
        const {
          achieveType,
          description,
          issueDate,
          title,
          issuingOrganization,
          id,
          parser,
        } = context.achievement;
        payload.events = [
          {
            achieveType,
            description,
            issueDate,
            title,
            issuingOrganization,
            id,
            parser,
          },
        ];
        addEvent(context, payload, keepOpen);
      } else {
        const {
          achieveType,
          description,
          issueDate,
          title,
          issuingOrganization,
          priorityID,
        } = context.achievement;
        payload.events = {
          achieveType,
          description,
          issueDate,
          title,
          issuingOrganization,
          priorityID,
        };
        editEvent(context, payload);
      }
    }
  } else {
    context.$v.achievement.$touch();
  }
};

const addProject = async (context, payload, keepOpen) => {
  try {
    const response = await postProjectsInfo(payload);
    if (response.status === 200) {
      context.loading = false;
      context.saveAndNewClicked = false;
      context.$nextTick(() => {
        context.successModal("Successfully added", "Project has been added");
      });
      if (context.$route.name === "Projects") {
        goToBoard(context);
      } else {
        (context.project = {
          title: null,
          role: null,
          domain: null,
          skillsUsed: [],
          responsibility: [""],
          description: null,
          summary: null,
          startDate: null,
          endDate: null,
          currentProject: false,
          client: null,
          association: null,
        }),
          context.$v.project.$reset();
        context.$emit("update-data", {
          modal: "showProjectModalNew",
          keepOpen,
        });
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const editProject = async (context, payload) => {
  try {
    const response = await putProjectEdit(payload);
    if (response.status === 200) {
      context.loading = false;
      context.$nextTick(() => {
        context.successModal(
          "Successfully updated",
          "Project have been updated"
        );
      });
      if (context.$route.name === "Projects") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showProjectModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updateProject = (context, keepOpen) => {
  context.$v.project.$touch();
  if (
    !context.$v.project.$invalid &&
    context.chkespValid &&
    !context.invalidEndDate
  ) {
    context.loading = true;
    if (keepOpen) context.saveAndNewClicked = true;
    if (context.project.responsibility.includes("")) {
      let emptyIndex = context.project.responsibility.indexOf("");
      while (emptyIndex !== -1) {
        context.project.responsibility.splice(emptyIndex, 1);
        emptyIndex = context.project.responsibility.indexOf("");
      }
    }
    let payload = {
      email: context.email,
      id: context.getcandidateInfo._id,
    };
    if (context.modalType === "add" || context.modalType === "addParser") {
      payload.projects = [context.project];
      addProject(context, payload, keepOpen);
    } else {
      payload.projects = { ...context.project };
      editProject(context, payload);
    }
  }
};

const addPortFolio = async (context, payload) => {
  try {
    const response = await addPortfolio(payload);
    if (response.status === 200) {
      context.loading = false;
      if (context.$route.name === "Portfolio") {
        goToBoard(context);
      } else {
        context.$emit("update-data", "showPortfolioModalNew");
      }
    } else {
      context.loading = false;
    }
  } catch (error) {
    context.loading = false;
    console.log(error);
  }
};

const updatePortfolio = async (context) => {
  if (context.checkValue === "check") {
    context.$v.$touch();
    if (
      !context.$v.portfolioName.$invalid &&
      !context.$v.portfolioLink.$invalid
    ) {
      return false;
    }
  } else if (context.checkValue === "save") {
    context.loading = true;
    let payload = {
      email: context.email,
      id: context.getcandidateInfo._id,
      parser: context.getcandidateInfo.hasOwnProperty("parser")
        ? context.getcandidateInfo.parser
        : null,
    };
    payload.portfolio = [
      ...context.uploadPortfolio,
      ...context.portfolioAddedParser,
    ];
    // await addPortFolio(context, payload);
    //For hobbies
    let payLoadHobbie;
    if (
      (context.editFullData && context.editFullData.parser) ||
      (context.getcandidateInfo && context.getcandidateInfo.parser)
    ) {
      payLoadHobbie = {
        email: context.email,
        hobbies: context.hobyNameListData,
        parserHobbies: context.hobyNameParserData,
        id: context.getcandidateInfo._id,
      };
    } else {
      payLoadHobbie = {
        email: context.email,
        hobbies: context.hobyNameListData,
        id: context.getcandidateInfo._id,
      };
    }
    const response = await postCandInfo(payLoadHobbie);
    await addPortFolio(context, payload);
    if (response.status == 200) {
      if (context.buttonText == "Save") {
        context.$nextTick(() => {
          context.successModal(
            "Successfully added",
            "Portfolio has been added"
          );
        });
      } else if (context.buttonText == "Update") {
        context.$nextTick(() => {
          context.successModal(
            "Successfully updated",
            "Portfolio have been updated"
          );
        });
      } else {
        context.$nextTick(() => {
          context.successModal(
            "Successfully deleted",
            "Portfolio have been deleted"
          );
        });
      }
    }
    return true;
  }
};

const updateProfile = async (context) => {
  context.$v.profile.$touch();
  if (!context.$v.profile.$invalid) {
    try {
      let form = new FormData();
      for (let key of Object.keys(context.profile)) {
        if (key !== "image") {
          form.append(key, context.profile[key]);
        }
      }
      const response = await postCandInfo(form);
      if (response.status === 200) {
        context.$nextTick(() => {
          context.successModal(
            "Successfully updated",
            "Profile have been updated"
          );
        });
        if (context.$route.name === "Profile") {
          goToBoard(context);
        } else {
          context.$emit("update-data", "showProfileModal");
        }
      } else {
        context.errorModal("Error", "Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    context.demo2form = false;
  }
};
const updateProfileNew = async (context, EventBus) => {
  context.$v.profile.$touch();
  if (
    !context.$v.profile.$invalid &&
    !context.nationalityError &&
    !context.invalidPhone &&
    !context.altinvalidPhone
  ) {
    try {
      context.loading = true;
      let checkimg = false;
      let form = new FormData();
      for (let key of Object.keys(context.profile)) {
        if (key !== "image" && key !== "resume") {
          form.append(key, context.profile[key]);
        }
      }
      form.append("id", context.getcandidateInfo._id);

      form.append("image", context.inputimage);
      form.append("email", context.profile.email);
      form.append("updateImage", context.updateImage);
      // form.append("getImage", true);
      if (context.updateImage) {
        checkimg = true
      } else {
        checkimg = false
      }
      const response = await postCandInfo(form);
      if (response.status === 200) {
        if (checkimg) {
          EventBus.$emit('get-information');
        }
        context.inputimage = null;
        context.profile.isProfilePictureUploaded = false;
        context.isImageChanged = false;
        context.updateImage = false;
        context.loading = false;
        if (!context.demo2form && context.buttonText == "Update") {
          context.$emit("update-data", "showBasicModalFullNew");
          context.$nextTick(() => {
            context.successModal(
              "Successfully updated",
              "Profile have been updated"
            );
          });
        } else {
          context.$emit("update-data", "showBasicModalFullNewok");
          context.$nextTick(() => {
            context.successModal(
              "Successfully added",
              "Profile has been added"
            );
          });
        }
        return true;
      } else {
        context.loading = false;
        return false;
      }
    } catch (error) {
      console.log(error);
      context.loading = false;
    }
  }
};

// Function to upload profile image
const uploadProfileImage = async (event, context) => {
  let inputs = event.target;
  if (inputs.files && inputs.files[0]) {
    const size = inputs.files[0].size;
    const fileSizeInMb = size / (1024 * 1024);
    if (fileSizeInMb > 2) {
      context.errorModal(
        "Upload failed",
        "Please upload an image with size less than 2MB"
      );
      return;
    }
    let reader = new FileReader();
    reader.onload = () => {
      context.$set(context.profile, "image", reader.result);
    };
    reader.readAsDataURL(inputs.files[0]);
    context.inputimage = inputs.files[0];
    context.profile.isProfilePictureUploaded = true;
    context.isImageChanged = true;
    context.updateImage = true;
  }
};

const deleteEducation = async (context, payload) => {
  try {
    const response = await deleteCandEdu(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Education have been deleted"
        );
      });
      await context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.delCheck = true;
      context.$nextTick(() => {
        context.errorModal("Error", "Something went wrong");
      });
    }
  } catch (error) {
    context.delCheck = true;
    console.log(error);
  }
};

const deletePortfolio = async (context, payload) => {
  try {
    const response = await deleteCandPortfolio(payload);
    if (response.status === 200) {
      context.clearDeleteData();
      context.getCommonFuncForProfile();
      context.delCheck = true;
      context.profileCompletion();
    } else {
      context.delCheck = true;
      context.$nextTick(() => {
        context.errorModal("Error", "Something went wrong");
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const deleteExperience = async (context, payload) => {
  try {
    const response = await deleteCandExp(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Experience have been deleted"
        );
      });
      context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.delCheck = true;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    context.delCheck = true;
    console.log(error);
  }
};

const deleteProject = async (context, payload) => {
  try {
    const response = await deleteCandProject(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Project have been deleted"
        );
      });
      context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.errorModal("Error", "Something went wrong");
      context.delCheck = true;
    }
  } catch (error) {
    console.log(error);
    context.delCheck = true;
  }
};

const deleteSkill = async (context, payload) => {
  try {
    const response = await deleteCandskills(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.$nextTick(() => {
        context.successModal("Successfully deleted", "Skill have been deleted");
      });
      if (context.$route.name === "CandidateDashboard") {
        context.clearDeleteData();
        context.getCommonFuncForProfile();
        context.delCheck = true;
      } else {
        context.delCheck = true;
        return true;
      }
    } else {
      context.errorModal("Error", "Something went wrong");
      context.delCheck = true;
      return false;
    }
  } catch (error) {
    console.log(error);
  }
};

const deleteDomain = async (context, payload) => {
  try {
    const response = await deleteCandDomain(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Domain have been deleted"
        );
      });
      if (context.$route.name === "CandidateDashboard") {
        context.clearDeleteData();
        context.getCommonFuncForProfile();
        context.delCheck = true;
      } else {
        context.delCheck = true;
        return true;
      }
    } else {
      context.delCheck = true;
      context.errorModal("Error", "Something went wrong");
      return false;
    }
  } catch (error) {
    console.log(error);
  }
};

const deleteAchieve = async (context, payload) => {
  try {
    const response = await deleteCandAchieve(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Achievement have been deleted"
        );
      });
      context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.delCheck = true;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    console.log(error);
  }
};
const deleteEvent = async (context, payload) => {
  try {
    const response = await deleteCandEvent(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Achievement have been deleted"
        );
      });
      context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.delCheck = true;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    console.log(error);
  }
};
const deleteAward = async (context, payload) => {
  try {
    const response = await deleteCandAward(payload);
    if (response.status === 200) {
      context.profileCompletion();
      context.clearDeleteData();
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Achievement have been deleted"
        );
      });
      context.getCommonFuncForProfile();
      context.delCheck = true;
    } else {
      context.delCheck = true;
      context.errorModal("Error", "Something went wrong");
    }
  } catch (error) {
    console.log(error);
  }
};

const uploadResume = async (resumeFile, email, context) => {
  try {
    let form = new FormData();
    form.append("email", email);
    form.append("resume", resumeFile);
    const response = await postCandInfo(form);
    if (response.status === 200) {
      context.profileCompletion();
      context.$nextTick(() => {
        context.successModal(
          "Successfully added",
          "Resume uploaded successfuly"
        );
      });
      context.getCommonFuncForProfile();
    }
  } catch (error) {
    console.log(error);
  }
};

const selectResume = (event, context) => {
  let inputs = event.target;
  if (inputs.files && inputs.files[0]) {
    const size = inputs.files[0].size;
    const fileSizeInMb = size / (1024 * 1024);
    if (fileSizeInMb > 10) {
      context.errorModal("Error", "File size should not exceed 10MB");
      return;
    }
  }
  if (inputs.files && inputs.files[0]) {
    var readers = new FileReader();
    readers.readAsDataURL(inputs.files[0]);
    if (context.uploadFrom) {
    } else {
      uploadResume(inputs.files[0], context.candidateInfo.email, context);
    }
  }
};

const deleteResume = async (context, email) => {
  try {
    context.delCheck = false;
    let payload = {
      email: email,
      resume: null,
    };

    const response = await postCandInfo(payload);
    if (response.status == 200) {
      context.profileCompletion();
      context.delCheck = true;
      context.$nextTick(() => {
        context.successModal(
          "Successfully deleted",
          "Resume have been deleted!"
        );
      });
      context.getCommonFuncForProfile();
    }
  } catch (error) {
    context.delCheck = true;

    console.log(error);
  }
};

const getUserCreditsData = async (context) => {
  try {
    const res = await getUserCredits();
    if (res.status == 200) {
      context.creditData = res.data.data;
    }
  } catch (error) {
    console.log(error);
  }
};

const loadRazorpayLibrary = (context, id) => {
  // Load Razorpay library dynamically
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.onload = () => {
    // Razorpay library loaded, now fetch and execute the HTML response
    paymentButtonShow(context, id);
  };
  document.head.appendChild(script);
};

const triggerClick = (context) => {
  const button = context.$refs.responseContainer.querySelector("button");
  if (button) {
    button.click();
  }
};

const paymentButtonShow = async (context, id) => {
  try {
    const resp = await goToPayment(id);
    if (resp.status == 200) {
      context.$nextTick(() => {
        context.$refs.responseContainer.innerHTML = resp.data;
        context.paymentButton = resp.data;
        executeScriptTags(context);
      });
    } else {
      context.paymentProcessing = false;
      context.errorModal("Error", "Payment failed !");
    }
  } catch (error) {
    console.log(error);
    context.paymentProcessing = false;
    context.errorModal("Error", "Payment failed !");
  }
};

const createNewOrder = async (context, payload) => {
  try {
    const response = await createOrder(payload);
    if (response.status == 201) {
      loadRazorpayLibrary(context, response.data.data.data.orderID);
    } else {
      context.paymentProcessing = false;
      context.showPayment = false;
      context.errorModal("Error", "Something went wrong !");
    }
  } catch (error) {
    console.log(error);
    context.paymentProcessing = false;
    context.showPayment = false;
    context.errorModal("Error", "Something went wrong !");
  }
};

const executeScriptTags = (context) => {
  // Find and execute script tags in the response HTML
  const scripts = context.$refs.responseContainer.querySelectorAll("script");
  scripts.forEach((script) => {
    const scriptContent = script.textContent || script.innerText;
    // Create a new script element
    const dynamicScript = document.createElement("script");
    // Set the script content to the extracted script
    dynamicScript.textContent = scriptContent;
    // Append the script to the DOM to execute it
    document.body.appendChild(dynamicScript);
    // Remove the script element to avoid memory leaks
    document.body.removeChild(dynamicScript);
  });
};

const checkCustomer = async (context, payload) => {
  try {
    const response = await checkCustomerExists(payload);
    if (response.status == 200) {
      context.customerID = response.data.data.customer.customerID;
      context.showPayment = true;
    } else {
      getLocationDetails(context);
    }
    context.payementClicked = false;
  } catch (error) {
    console.log(error);
    getLocationDetails(context);
  }
};

const getLocationDetails = async (context) => {
  if (Capacitor.isNativePlatform()) {
    try {
      const permissionStatus = await Geolocation.checkPermissions();
      if (permissionStatus.location !== "granted") {
        const requestStatus = await Geolocation.requestPermissions();
        if (requestStatus.location !== "granted") {
          context.startDownload = false;
          context.errorModal(
            "Error",
            "Location permission is mandatory. Please grant permission."
          );
          return;
        }
      }

      const position = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 10000,
      });

      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      if (latitude && longitude) {
        getUserLocation(context, latitude, longitude);
      }
    } catch (error) {
      console.error("Error getting geolocation:", error);
      context.startDownload = false;

      if (error.message === "Location services are not enabled") {
        // Trigger the mandatory location modal
        if (context.hasOwnProperty('showLocationModal')) {
          context.showLocationModal = true;
        } else {
          context.errorModal(
            "Location Disabled",
            "Please enable Location Services (GPS) on your device."
          );
        }
      } else {
        context.errorModal(
          "Error getting location",
          "An error occurred while fetching your location."
        );
      }
    }
  } else {
    // Fallback to web implementation
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          if (latitude && longitude) {
            getUserLocation(context, latitude, longitude);
          }
        },
        (error) => {
          context.startDownload = false;
          context.errorModal(
            "Error getting location",
            "Please enable location permission to continue!"
          );
          console.error("Error getting geolocation:", error.message);
        }
      );
    } else {
      context.startDownload = false;
      context.errorModal(
        "Error",
        "Geolocation is not supported by this browser."
      );
    }
  }
};

const getUserLocation = async (context, latitude, longitude) => {
  try {
    let payload = {
      latitude: latitude.toString(),
      longitude: longitude.toString(),
    };
    const response = await getLocation(payload);
    if (response.status == 200) {
      createNewCustomer(context, response.data.data.formatted_address);
    } else {
      context.startDownload = false;
      context.errorModal("Error", "Something went wrong !");
    }
  } catch (error) {
    console.log(error);
    context.startDownload = false;
    context.errorModal("Error", "Something went wrong !");
  }
};

const createNewCustomer = async (context, address) => {
  try {
    let payload = {
      fullName: context.userName,
      customerAddress: address,
      email: context.userEmail,
      phoneNumber: context.candidateInfoState.phoneNumber,
    };
    const response = await createCustomer(payload);
    if (response.status == 200) {
      context.customerID = response.data.data.customer.customerID;
      context.showPayment = true;
    } else {
      context.startDownload = false;
      context.errorModal("Error", "Something went wrong !");
    }
  } catch (error) {
    console.log(error);
    context.startDownload = false;
    context.errorModal("Error", "Something went wrongg !");
  }
};

const addUserCreditValue = async (context, orderid) => {
  try {
    let payload = {
      orderID: orderid,
    };
    const response = await addUserCredits(payload);
    if (response.status == 200) {
      context.startDownload = true;
    } else {
      context.startDownload = false;
      context.errorModal("Error", "Payment failed, Please try again");
    }
  } catch (error) {
    context.startDownload = false;
    context.errorModal("Error", "Payment failed, Please try again");
  }
};

module.exports = {
  getCandidateDetail,
  addBasicDetail,
  addBasicDetailNew,
  addEducation,
  addExperience,
  addProject,
  updateEducation,
  updateExperience,
  updateSkill,
  updateDomain,
  updateAchieve,
  updateProject,
  updatePortfolio,
  updateProfile,
  updateProfileNew,
  uploadProfileImage,
  deleteEducation,
  deletePortfolio,
  deleteExperience,
  deleteProject,
  deleteSkill,
  deleteDomain,
  deleteAchieve,
  deleteEvent,
  deleteAward,
  selectResume,
  deleteResume,
  getUserCreditsData,
  checkCustomer,
  createNewOrder,
  triggerClick,
  addUserCreditValue,
};
